import type { InjectionKey } from 'vue';
import type { NormalizedPreconToastsGlobalOptions } from './options';

/**
 * The injection to get the options into the components.
 */
export const preconToastsOptionsInjectionKey = Symbol(
    'precon-toasts library options'
) as InjectionKey<Readonly<NormalizedPreconToastsGlobalOptions>>;
